import { constant } from "constants";

Array.prototype.mapWithKey = function (callback) {
  let newArray = [];
  for (let index = 0; index < this.length; index++) {
    let counter = callback(
      this[index],
      JSON.stringify(this[index]),
      index,
      this
    );
    newArray.push(counter);
  }
  return newArray;
};

export const utils = {
  isEqualObject: (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2),

  isObjectValueEmpty: (obj) =>
    Object.values(obj).every(
      (item) => item !== "" || item !== "undefined" || item !== undefined
    )
      ? true
      : false,

  isObjectKeyEmpty: (obj) => (Object.keys(obj).length ? false : true),
  isObjectKeyExist: (obj, key) => Object.keys(obj).includes(key),

  checkFormError: async (inputValue, schema) => {
    try {
      const validationResult = await schema.validate(inputValue, {
        abortEarly: false,
      });
      return !!validationResult;
    } catch (error) {
      let obj = {};
      error?.inner?.forEach((vr) => {
        obj[vr.path] = vr.errors[0];
      });
      return obj;
    }
  },
  dynamicCheckFormError: async (formValue, schema, context) => {
    try {
      await schema.validate(formValue, { abortEarly: false, context: context });
      return true;
    } catch (err) {
      const errors = {};
      err?.inner?.forEach((error) => {
        errors[error.path] = error.message;
      });
      return errors;
    }
  },
  getResposeError: (resError) => {
    let error = "";
    if (typeof resError === "string") {
      error = resError;
    } else {
      for (const key in resError) {
        if (Object.hasOwnProperty.call(resError, key)) {
          error =
            typeof resError[key] === "string"
              ? resError[key]
              : resError[key][0];
        }
      }
    }
    return error;
  },

  getResponseAllErrors: (resError) => {
    let error = {};
    for (const key in resError) {
      if (Object.hasOwnProperty.call(resError, key)) {
        error[key] = resError[key][0];
      }
    }
    return error;
  },

  queryString: (params) =>
    Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&"),

  spliceString: (
    text = "", // string
    start = 0, // index
    end = 0, // index
    join = "", // character
    from = "", // character
    to = 0 //lenght or count
  ) => {
    if (from !== "") {
      let ind = text.indexOf(".");
      return (
        text.slice(start, end > ind ? ind : end) +
        join +
        text.slice(ind, text.length)
      );
    } else {
      return text?.slice(start, end);
    }
  },

  spliceStringForCompany: (text = "", limit = 0) => {
    if (!text) return "";

    if (text.length > limit) {
      return text.slice(0, limit) + "...";
    }

    return text;
  },


  firstLetterCapital: (word = "") =>
    word?.length > 1
      ? word?.charAt(0).toUpperCase() + word?.slice(1)
      : word?.toUpperCase(),

  capitalFirstLetter: (word = "") =>
    word?.length > 1 ? word?.charAt(0).toUpperCase() : "NA",

  convertParseFloat: (num) =>
    num != 0 ? parseFloat(num).toFixed(2).replace(/\.00$/, "") : num,

  lengthBeforeDecimal: (number) => {
    const numberStr = number.toString();
    const decimalIndex = numberStr.indexOf(".");
    if (decimalIndex === -1) {
      return numberStr.length;
    } else {
      return decimalIndex;
    }
  },

  formatDate: (date = "") => {
    if (!date) {
      return "";
    }
    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");

    return `${year}/${month}/${day}`;
  },
  // formate wise date
  dd_mm_yy_formatDate: (date = "") => {
    if (!date) {
      return "";
    }
    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");

    return `${day}/${month}/${year}`;
  },

  getDayOfDate: (date, count, act = "add") => {
    const resultDate = new Date(date);
    switch (act) {
      case "sub":
        resultDate.setDate(resultDate.getDate() - count);
        break;
      case "add":
        resultDate.setDate(resultDate.getDate() + count);
        break;
    }
    return utils.formatDate(resultDate);
  },

  stringMonthDate: (val) => {
    const value1 = utils?.formatDate(val).split("/")[1];
    const value2 = utils?.formatDate(val).split("/")[2];

    const value3 = constant?.monthList?.filter((el) =>
      +el?.value === +value1 ? el : ""
    )[0];

    const value4 = utils?.spliceString(value3?.label, 0, 3);

    return `${value4} ${value2}`;
  },

  formatAMPM: (data) => {
    var date = new Date(data);
    var hours = date?.getHours();
    var minutes = date?.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  },

  dateInStringForm: (val) => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const d = new Date(val);
    const dayName = days[d.getDay()];
    const value0 = utils?.formatDate(val).split("/")[0];
    const value1 = utils?.formatDate(val).split("/")[1];
    const value2 = utils?.formatDate(val).split("/")[2];

    const value3 = constant?.monthList?.filter((el) =>
      +el?.value === +value1 ? el : ""
    )[0];

    const value4 = value3?.label;

    return `On ${dayName} ${value2} ${value4} ${value0}`;
  },

  is6ValidNumber: (value) => /^[0-9]{1,6}$/.test(value),

  convertQueryParamsObject: (param, length) => {
    let obj = {};
    param.forEach((value, key) => {
      obj[key] = value;
    });
    return obj;
  },

  isValidURL: (str) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?" + // port
      "(\\/[-a-z\\d%_.~+]*)*" + // path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(str);
  },

  isImageLink: (url) => {
    const imageRegex = /image|\.jpeg|\.jpg|\.gif|\.png|\.svg(\?.*)?$/;
    return imageRegex.test(url);
  },

  isVideoLink: (url) => {
    const directLinkPattern = /\.(mp4|webm|ogg|mov)$/i;
    const youTubePattern = /youtube\.com|youtu\.be/i;
    const vimeoPattern = /vimeo\.com/i;
    const dailymotionPattern = /dailymotion\.com/i;

    return (
      directLinkPattern.test(url) ||
      youTubePattern.test(url) ||
      vimeoPattern.test(url) ||
      dailymotionPattern.test(url)
    );
  },

  removeHashtag: (str) => {
    if (!str) return "";
    return str.startsWith("#") ? str.substring(1) : str;
  },
  isUrl: (text) => {
    const urlRegex = /(http|https):\/\/(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim;
    const urlRegex2 = /(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim;

    if (text.match(urlRegex)) {
      return true;
    } else if (text.match(urlRegex2)) {
      return true;
    }

    return false;
  },
  convertURLsToAnchors: (text) => {
    // Regular expression to match URLs
    const urlRegex = /(http|https):\/\/(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim;
    const urlRegex2 = /(\S+)\.([a-z]{2,}?)(.*?)( |\,|$|\.)/gim;

    if (text.match(urlRegex)) {
      return text.replace(urlRegex, (url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });
    } else if (text.match(urlRegex2)) {
      return text.replace(urlRegex2, (url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });
    }

    return text;
  },
  getTodayDate: (isDate) => {
    const today = isDate ? new Date(isDate) : new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  },
  customizeDate: (dateStr, half = true) => {
    const date = new Date(dateStr);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    const fullNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const halfNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthName = half ? halfNames[date.getUTCMonth()] : fullNames[date.getUTCMonth()];

    return `${day} ${monthName} ${year}`;
  },
  stripHtmlTags: (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  },
  disableConsoleLogs: () => {
    console.clear();
    console.log = () => { };
    console.info = () => { };
    console.warn = () => { };
    console.error = () => { };
    console.debug = () => { };
  },
  // const div = document.createElement('div');
  // div.innerHTML = html;

  //   // Get the first <p> element
  //   const firstP = div.querySelector('p');

  //   // Return the text content of the first <p> element, or the full text content if no <p> elements
  //   return firstP ? firstP.textContent || firstP.innerText : div.textContent || div.innerText || '';
  // }

  //     const div = document.createElement('div');
  //   div.innerHTML = html;

  //   // Get all <p> elements
  //   const pElements = div.querySelectorAll('p');

  //   // Extract text content from each <p> element and join with a separator
  //   const textContents = Array.from(pElements).map(node => node.textContent || node.innerText || '');
  //   return textContents.join(' - ');
  // }
  getDateTwoDaysAfterDate: () => {
    const today = new Date();
    const twoDaysLater = new Date(today);
    twoDaysLater.setDate(today.getDate() + 2);

    const year = twoDaysLater.getFullYear();
    const month = String(twoDaysLater.getMonth() + 1).padStart(2, "0");
    const day = String(twoDaysLater.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  },
  localDateWithTime: (date) => {
    const now = new Date(date);
    const formattedDate = now.toDateString();
    const formattedTime = now.toLocaleString("en-US", { timeStyle: "short" });
    return `${formattedDate} ${formattedTime}`;
  },

  formatDateMonth: (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  },

  formatTime: (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  },
  formateDateCalander: (date) => {
    if (date) {
      const today = new Date(date);
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${day}-${month}-${year}`;
    } else {
      return new Date();
    }
  },
  getDateFifteenDaysAfterDate: (date) => {
    const today = new Date(date);
    const fifteenDaysLater = new Date(today);
    fifteenDaysLater.setDate(today.getDate() + 15);

    const year = fifteenDaysLater.getFullYear();
    const month = String(fifteenDaysLater.getMonth() + 1).padStart(2, "0");
    const day = String(fifteenDaysLater.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  },

  convertToISO: (dateString, toIST = false) => {
    const dateObject = new Date(dateString);

    if (isNaN(dateObject?.getTime())) {
      throw new Error("Invalid date string");
    }

    if (toIST) {
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, "0");
      const day = String(dateObject.getDate()).padStart(2, "0");
      const hours = String(dateObject.getHours()).padStart(2, "0");
      const minutes = String(dateObject.getMinutes()).padStart(2, "0");
      const seconds = String(dateObject.getSeconds()).padStart(2, "0");
      const milliseconds = String(dateObject.getMilliseconds()).padStart(
        3,
        "0"
      );

      // Return the date in the format `yyyy-mm-ddThh:mm:ss.sss+05:30`
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}+05:30`;
    }
    const isoString = dateObject.toISOString();

    return isoString;
  },

  convertISOToReadableFormat: (isoString) => {
    const dateObject = new Date(isoString);

    if (isNaN(dateObject.getTime())) {
      throw new Error("Invalid ISO string");
    }

    // Convert to Indian Standard Time (IST)
    const options = {
      timeZone: "Asia/Kolkata",
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // 24-hour format
    };

    const formattedDate = dateObject.toLocaleString("en-US", options);
    const timeZoneName = "GMT+0530 (India Standard Time)";

    return `${formattedDate} ${timeZoneName}`;
  },

  formatTimeWithoutConvert: (isoString) => {
    const timePart = isoString.split("T")[1]; // Get the part after "T"
    const [hours, minutes] = timePart.split(":"); // Extract hours and minutes
    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? "PM" : "AM"; // Determine AM/PM
    const formattedHour = hour % 12 || 12; // Convert to 12-hour format
    return `${formattedHour}:${minutes} ${period}`;
  },
  getDateByApiResponse: (date = "", keyword = "/") => {
    const today = new Date(date);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${day}${keyword}${month}${keyword}${year}`;
  },
  getTotalAmount: (data, key) => {
    try {
      if (!Array.isArray(data)) return 0;
      const total = data.reduce((sum, item) => {
        const val = parseFloat(item?.[key]) || 0;
        return sum + val;
      }, 0);
      return parseFloat(total.toFixed(2));
    } catch (error) {
      return 0;
    }
  },
  getLedgerTotalAmount: (data, key) => {
    try {
      if (!Array.isArray(data)) return 0;
      return data.reduce((total, item) => {
        return total + (item?.vendor_detail?.[key] || 0);
      }, 0);
    } catch (error) {
      return 0;
    }
  },
  maxLengthCheck: (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  },
  handleMobileInputChange: (event, handleOnChange) => {
    const { name, value } = event.target;
    let cleanedValue = value.replace(/\D/g, "");
    if (cleanedValue.startsWith("91") && cleanedValue.length > 10) {
      cleanedValue = cleanedValue.substring(2);
    }
    if (/^\d{0,10}$/.test(cleanedValue)) {
      handleOnChange(name, cleanedValue);
    }
  },
  handleNameInputChange: (event, handleOnChange) => {
    const { name, value } = event.target;
    let cleanedValue = value.trimStart();
    if (/^[^a-zA-Z]/.test(cleanedValue)) {
      return;
    }
    cleanedValue = cleanedValue.replace(/[^a-zA-Z0-9\s&'-.]/g, "");
    handleOnChange(name, cleanedValue);
  },
  handleOpeningBalanceInputChange: (event, handleOnChange) => {
    const { name, value } = event.target;
    const validValue = value.replace(/[^0-9.]/g, "");
    const formattedValue = validValue.includes(".")
      ? validValue.split(".")[0] + "." + validValue.split(".")[1].slice(0, 2)
      : validValue;

    handleOnChange(name, formattedValue);
  },

  handleNoSpecialCharInputChange: (event, handleOnChange) => {
    const { name, value } = event.target;

    // Remove all special characters, allow letters, digits, and space
    const cleanedValue = value.replace(/[^a-zA-Z0-9 ]+/g, "");

    if (typeof handleOnChange === "function") {
      handleOnChange(name, cleanedValue);
    }
  },

  handleNameWithoutNumberChange: (event, handleOnChange) => {
    const { name, value } = event.target;

    // Remove leading whitespace
    let cleanedValue = value.trimStart();

    // Block if the first character is not a letter
    if (/^[^a-zA-Z]/.test(cleanedValue)) {
      return;
    }

    // Allow only letters, space, apostrophe, hyphen, and period — NO NUMBERS
    cleanedValue = cleanedValue.replace(/[^a-zA-Z\s&'.-]/g, "");

    handleOnChange(name, cleanedValue);
  },

  // very special onChange
  // not allow any Special characters: ! @ # $ % ^ & * ( ) ~ `
  // not allow any dot (.)
  // not allow Letters: a-z, A-Z
  // not allow any Spaces or blank spaces
  withoutDotLettersSpaceSpecialCharacters: (event, handleOnChange) => {
    const { name, value } = event.target;
    const cleanedValue = value.replace(/[^0-9]/g, "");
    if (typeof handleOnChange === "function") {
      handleOnChange(name, cleanedValue);
    }
  },
  shouldShowButton: (dateLike) => {
    const target = new Date(dateLike);
    const nowUtc = new Date();

    const targetMidnight = Date.UTC(
      target.getUTCFullYear(),
      target.getUTCMonth(),
      target.getUTCDate()
    );
    const todayMidnight = Date.UTC(
      nowUtc.getUTCFullYear(),
      nowUtc.getUTCMonth(),
      nowUtc.getUTCDate()
    );

    return targetMidnight <= todayMidnight;
  },
  // This getReminderDate function will work , if i give today date and number of days so it will return before date,
  // formula = 30 july 2025 - 15 days =  15 july 2025
  getReminderDate: (expiryDate, daysBefore) => {
    const today = expiryDate ? new Date(expiryDate) : new Date();
    const reminderDate = new Date(today);
    reminderDate.setDate(today.getDate() - daysBefore + 1);
    const formattedDate = reminderDate.toLocaleDateString('en-CA'); // reminderDate.toISOString().split("T")[0];
    return formattedDate;
  },
  // formula = 30 July , 1 July ,if today date exist between 30 July and 1 July day,
  // it will return true otherwise false;
  isTodayBetweenDates: (reminderDateStr, expiryDateStr) => {
    const reminderDate = new Date(reminderDateStr);
    const expiryDate = new Date(expiryDateStr);
    reminderDate.setHours(0, 0, 0, 0);
    expiryDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today >= reminderDate && today <= expiryDate;
  },
  // if date and today date are same so it will return false,
  // if date is 25 july, so and today date is 26 july so it will return true,
  // if date is 30 july and today date is 26 july so it will return false.
  isDateInPastOrToday: (dateStr) => {
    const inputDate = new Date(dateStr);
    inputDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return inputDate < today;
  },
  // formula : (future date - today date) = number of days left,
  getDaysLeftUntilDate: (futureDateStr) => {
    const futureDate = new Date(futureDateStr);
    const today = new Date();
    futureDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffInMs = futureDate - today;
    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
    return diffInDays > 0 ? diffInDays : 0;
  },
  // This getTimeDifferenceFromToday function use both formula
  // formula : (future date - today date) = year, month, day left,
  // formula : (today date - past date) = year, month, day ago,
  getTimeDifferenceFromToday: (inputDateStr) => {
    const inputDate = new Date(inputDateStr);
    const today = new Date();

    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    let isFuture = inputDate > today;

    let start = isFuture ? today : inputDate;
    let end = isFuture ? inputDate : today;

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();
    let days = end.getDate() - start.getDate();

    if (days < 0) {
      months -= 1;
      const prevMonth = new Date(end.getFullYear(), end.getMonth(), 0);
      days += prevMonth.getDate();
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    const parts = [];
    if (years) parts.push(`${years} year${years !== 1 ? "s" : ""}`);
    if (months) parts.push(`${months} month${months !== 1 ? "s" : ""}`);
    if (days) parts.push(`${days} day${days !== 1 ? "s" : ""}`);

    if (parts.length === 0) return "Today";

    return isFuture ? `${parts.join(", ")} left` : `${parts.join(", ")} ago`;
  },
  // formula startDate, startTime, endDate, endTime = total time duration
  getDuration: (startDate, startTime, endDate, endTime) => {
    const start = new Date(`${startDate} ${startTime}`);
    const end = new Date(`${endDate} ${endTime}`);

    const diffMs = end - start;

    if (diffMs < 0) return "Invalid: End date/time is before start date/time";

    const totalMins = Math.floor(diffMs / 60000);

    const days = Math.floor(totalMins / (24 * 60));
    const hours = Math.floor((totalMins % (24 * 60)) / 60);
    const minutes = totalMins % 60;

    const pluralize = (value, label) =>
      `${value} ${label}${value !== 1 ? "s" : ""}`;
    let finalDay = days > 0 ? pluralize(days, "day") : "";
    let finalHours = hours > 0 ? pluralize(hours, "hour") : "";
    let finalMinutes = minutes > 0 ? pluralize(minutes, "min") : "";

    return `${finalDay} ${finalHours} ${finalMinutes}`;
  },
  newGetDuration: (startDate, endDate) => {
    // Parse the dates (handles both ISO strings and separate date/time)
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Check for invalid dates
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return "-";
    }

    const diffMs = end - start;

    if (diffMs < 0) return "-";

    const totalSeconds = Math.floor(diffMs / 1000);
    const totalMins = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMins / 60);

    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const minutes = totalMins % 60;
    const seconds = totalSeconds % 60;

    const parts = [];

    if (days > 0) {
      parts.push(`${days} day${days !== 1 ? 's' : ''}`);
    }
    if (hours > 0) {
      parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes} min`);
    }
    // Only show seconds if duration is less than 1 minute
    if (seconds > 0 && totalMins < 1) {
      parts.push(`${seconds} sec`);
    }

    // Handle case where dates are identical
    if (parts.length === 0) {
      return "0 min";
    }

    return parts.join(', ');
  },
  // formula Average Speed = Total Distance / Total Time
  // distance always in km , time always in minutes
  getAvarageSpeed: (startDate, startTime, endDate, endTime, distanceKm) => {
    const start = new Date(`${startDate} ${startTime}`);
    const end = new Date(`${endDate} ${endTime}`);

    const diffMs = end - start;

    if (diffMs < 0) return "Invalid: End date/time is before start date/time";

    const totalMins = Math.floor(diffMs / 60000);

    if (totalMins <= 0) return "Invalid time";
    if (distanceKm < 0) return "Invalid distance";

    const timeHours = totalMins / 60;
    const averageSpeed = distanceKm / timeHours;

    return `${averageSpeed.toFixed(2)} km/h`;
  },
  // using epoch get the date
  epochFormatDate: (date) => {
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day} ${month}, ${year}, ${hours
      .toString()
      .padStart(2, "0")}:${minutes} ${ampm}`;
  },
  parseCustomDate: (dateInput) => {
    // If input is already a Date object, return it directly
    if (dateInput instanceof Date) {
      return dateInput;
    }

    // Otherwise, parse the string
    const [datePart, timePart] = dateInput.split(" ");
    const [day, month, year] = datePart.split("/");

    // If no time part, default to 00:00:00 (start of day)
    if (!timePart) {
      const isoString = `${year}-${month}-${day}T00:00:00`;
      return new Date(isoString);
    }

    // Parse time if available
    const [time, modifier] = timePart.split(" ");
    let [hours, minutes, seconds] = time.split(":");

    // Convert to 24-hour format
    if (modifier === "PM" && hours !== "12") {
      hours = parseInt(hours, 10) + 12;
    } else if (modifier === "AM" && hours === "12") {
      hours = "00";
    }

    // Create ISO format string (YYYY-MM-DDTHH:mm:ss)
    const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    return new Date(isoString);
  },
  // give a number and return state name,
  codeToStateName: {
    1: "Jammu Kashmir",
    2: "Himachal Pradesh",
    3: "Punjab",
    4: "Chandigarh",
    5: "Uttarakhand",
    6: "Haryana",
    7: "Delhi",
    8: "Rajasthan",
    9: "Uttar Pradesh",
    10: "Bihar",
    11: "Sikkim",
    12: "Arunachal Pradesh",
    13: "Nagaland",
    14: "Manipur",
    15: "Mizoram",
    16: "Tripura",
    17: "Meghalaya",
    18: "Assam",
    19: "West Bengal",
    20: "Jharkhand",
    21: "Odisha",
    22: "Chhattisgarh",
    23: "Madhya Pradesh",
    24: "Gujarat",
    26: "Dadra Nagar Haveli And Daman And Diu",
    27: "Maharashtra",
    29: "Karnataka",
    30: "Goa",
    31: "Lakshadweep",
    32: "Kerala",
    33: "Tamil Nadu",
    34: "Puducherry",
    35: "Andaman Nicobar Islands",
    36: "Telangana",
    37: "Andhra Pradesh",
    38: "Ladakh"
  },
  codeToStateNameObject: {
    1: { label: "Jammu Kashmir", value: "Jammu Kashmir" },
    2: { label: "Himachal Pradesh", value: "Himachal Pradesh" },
    3: { label: "Punjab", value: "Punjab" },
    4: { label: "Chandigarh", value: "Chandigarh" },
    5: { label: "Uttarakhand", value: "Uttarakhand" },
    6: { label: "Haryana", value: "Haryana" },
    7: { label: "Delhi", value: "Delhi" },
    8: { label: "Rajasthan", value: "Rajasthan" },
    9: { label: "Uttar Pradesh", value: "Uttar Pradesh" },
    10: { label: "Bihar", value: "Bihar" },
    11: { label: "Sikkim", value: "Sikkim" },
    12: { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
    13: { label: "Nagaland", value: "Nagaland" },
    14: { label: "Manipur", value: "Manipur" },
    15: { label: "Mizoram", value: "Mizoram" },
    16: { label: "Tripura", value: "Tripura" },
    17: { label: "Meghalaya", value: "Meghalaya" },
    18: { label: "Assam", value: "Assam" },
    19: { label: "West Bengal", value: "West Bengal" },
    20: { label: "Jharkhand", value: "Jharkhand" },
    21: { label: "Odisha", value: "Odisha" },
    22: { label: "Chhattisgarh", value: "Chhattisgarh" },
    23: { label: "Madhya Pradesh", value: "Madhya Pradesh" },
    24: { label: "Gujarat", value: "Gujarat" },
    26: { label: "Dadra Nagar Haveli And Daman And Diu", value: "Dadra Nagar Haveli And Daman And Diu" },
    27: { label: "Maharashtra", value: "Maharashtra" },
    29: { label: "Karnataka", value: "Karnataka" },
    30: { label: "Goa", value: "Goa" },
    31: { label: "Lakshadweep", value: "Lakshadweep" },
    32: { label: "Kerala", value: "Kerala" },
    33: { label: "Tamil Nadu", value: "Tamil Nadu" },
    34: { label: "Puducherry", value: "Puducherry" },
    35: { label: "Andaman Nicobar Islands", value: "Andaman Nicobar Islands" },
    36: { label: "Telangana", value: "Telangana" },
    37: { label: "Andhra Pradesh", value: "Andhra Pradesh" },
    38: { label: "Ladakh", value: "Ladakh" }
  },
  deepCompare: (obj1, obj2) => {
    if (obj1 === obj2) return true;

    if (typeof obj1 !== "object" || obj1 === null ||
      typeof obj2 !== "object" || obj2 === null) {
      return false;
    }
    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (!keys2.includes(key) || !utils?.deepCompare(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  },

  calculateRemainingDays: (endDate) => {
    if (!endDate) return 0;

    const today = new Date();
    const end = new Date(endDate);
    const diffMs = end - today;
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    return diffDays >= 0 ? diffDays : 0;
  }
  ,
  formatUiDateTime: (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} | ${hours}:${minutes} ${ampm}`;
  },
  // This getDateAfterDays function will work , if i give today date and number of days so it will return after date,
  // formula = 01 july 2025 + 15 days =  16 july 2025
  getDateAfterDays: (startDate, daysAfter) => {
    const baseDate = startDate ? new Date(startDate) : new Date();
    const reminderDate = new Date(baseDate);
    reminderDate.setDate(baseDate.getDate() + Number(daysAfter));
    const formattedDate = reminderDate.toLocaleDateString('en-CA'); // yyyy-mm-dd format
    return formattedDate;
  },
  handleKeyDown: (event) => {
    function isValidNumber(val) {
      if (val === "" || val === "+" || val === "-") return true;
      return !!(!isNaN(val) && !isNaN(parseFloat(val)));
    }

    function isSpace(str) {
      return str === " ";
    }

    function isWhitelistedKey(key) {
      const whitelistedActions = [
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Delete",
        "."
      ];
      return whitelistedActions.includes(key);
    }

    const currentValue = event.target.value;
    const key = event.key;

    // 1️⃣ Allow only one + or - at the first position
    if (key === "+" || key === "-") {
      // If + or - is not at position 0 => block
      if (event.target.selectionStart !== 0) {
        event.preventDefault();
        return;
      }

      // If already has + or - => block
      if (currentValue.startsWith("+") || currentValue.startsWith("-")) {
        event.preventDefault();
        return;
      }

      return; // Allow + or -
    }

    // 2️⃣ Decimal logic
    if (currentValue.includes('.') && !isWhitelistedKey(key)) {
      const decimalPart = currentValue.split('.')[1];

      if (decimalPart && decimalPart.length >= 2 && /^\d$/.test(key)) {
        event.preventDefault();
        return;
      }
    }

    // 3️⃣ Dot allowed only once
    if (key === '.' && currentValue.includes('.')) {
      event.preventDefault();
      return;
    }

    // 4️⃣ Allow whitelisted actions
    if (isWhitelistedKey(key)) return;

    // 5️⃣ Block spaces or invalid numbers
    if (isSpace(key) || !isValidNumber(currentValue + key)) {
      event.preventDefault();
      return;
    }
  },
  getDate: (isDate, type = '-', format = 'dmy') => {
    const today = isDate ? new Date(isDate) : new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    if (format === 'dmy') {
      return `${day}${type}${month}${type}${year}`;
    } else {
      return `${year}${type}${month}${type}${day}`;
    }
  },
  parseUTCAsLocal: (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();

    return new Date(year, month, day, hours, minutes, seconds);
  },
  specificName: (name) => {
    if (!name) return '';
    const result = name?.split('_')?.join(' ');
    return utils.firstLetterCapital(result);
  }
};




